import {
  __federation_method_getRemote,
  __federation_method_setRemote,
} from 'virtual:__federation__'

const registered = new Set()

// Runtime module-federation loading — the pattern from the todofi research.
// The bundle at entry.url was built by @originjs/vite-plugin-federation as a
// remote; we register it under its scope once, then pull the exposed module.
export async function loadPluginModule(entry) {
  if (!registered.has(entry.scope)) {
    __federation_method_setRemote(entry.scope, {
      url: () => Promise.resolve(entry.url),
      format: 'esm',
      from: 'vite',
    })
    registered.add(entry.scope)
  }
  const module = await __federation_method_getRemote(entry.scope, entry.module)
  return module?.default ?? module
}
